import { useTheme } from '@mui/material';
import React from 'react';

function SupText(props: { symbol: string; fs?: string; colorText?: string; fw?: number }) {
    const theme = useTheme();
    const { symbol, fs = '0.65rem', colorText = theme.palette.dark.dark, fw = 700 } = props;
    return <sup style={{ verticalAlign: 'super', fontSize: fs, fontWeight: fw, color: colorText }}>{symbol}</sup>;
}

export default SupText;
